"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    GOOGLE: 'google',
    APPLE: 'apple',
    COMMUNITY: 'community',
};
//# sourceMappingURL=calendarSourceTypes.js.map